'use strict'

/**
 * Composant Header
 */

import modal from 'Modules/modal'
import inscriptionModule from 'Modules/inscriptionModule'
import inscriptionConnexionCustomAction from 'Modules/inscriptionConnexionCustomAction'
import { PopIn3M } from 'Modules/fusion3m'

/**
 * LAYOUT
 */

const J_BODY_OVERLAY = '.overlay-menu'

// Gère l'affichage de l'overlay
function updateBodyOverlayMenu(hasActiveMenu) {
    if (hasActiveMenu) {
        $(J_BODY_OVERLAY).addClass('active')
        return
    }

    $(J_BODY_OVERLAY).removeClass('active')
}

/**
 * MENU
 */
const J_MENU = '.j_outMenu'

// Ajout le style à l'élément du menu qui est hover
$(J_MENU).hover(function () {
    const navActifDefautContainer = document.getElementById('j_menuActifDefaut')

    if (navActifDefautContainer == null) {
        return
    }

    $('.navigationGenre').removeClass('menuActive')
    $('#' + navActifDefautContainer.value).addClass('menuActive')
    updateBodyOverlayMenu(false)
    $('.menu__item__link').removeClass('menu__item__link--active')
    $("[data-idNavGender*='" + navActifDefautContainer.value + "'] a").addClass(
        'menu__item__link--active'
    )
})

/**
 * GENRES
 */
const J_MENU_GENRES = '.js-menu'
const J_GENDER_DATA = 'gender'

// Gère le chargement des catégories du menu par genre
$(J_MENU_GENRES).on('mouseenter', function () {
    const _self = $(this)
    const genre = _self.data(J_GENDER_DATA)

    if (genre == undefined) {
        return
    }

    // Vérifies qu'il s'agit bien d'un menu de catégories
    if (_self.parent().attr('id') == 'menuDesign') {
        const navGenre = _self.attr('data-idNavGender')

        // Définis le menu comme menu actif
        if (!$('#' + navGenre).hasClass('menuActive')) {
            $('.navigationGenre').removeClass('menuActive')
            updateBodyOverlayMenu(true)
            $('#' + navGenre).addClass('menuActive')
            $('.menu__item__link').removeClass('menu__item__link--active')
            $("[data-idNavGender*='" + navGenre + "'] a").addClass(
                'menu__item__link--active'
            )
        }
    }

    const capitalizedGenre =
        genre.charAt(0).toUpperCase() + genre.slice(1).toLowerCase()

    // Vérifie si les données du menu ont déjà été chargées
    const isMenuLoaded = Boolean(_self.children('.menu__container').length)
    const isMenuDesignLoaded = Boolean(
        $('#navMenu' + capitalizedGenre).children('.menu__container').length
    )

    if (isMenuLoaded || isMenuDesignLoaded) {
        // Gère l'offuscation des liens
        addAnchorsEventListeners()
        return
    }

    // Charge les données du menu
    $.ajax({
        type: 'GET',
        url: '/Layout/Menu/?codegenre=' + genre,
        success: function (response) {
            // Ajoute les catégories au menu
            $('#navMenu' + capitalizedGenre).append(response)

            // Gère l'offuscation des liens
            addAnchorsEventListeners()
            $('.linkAjaxReload').unbind('click')
            $('.linkAjaxReload').click(function () {
                window.location = $(this).attr('data')
            })
        }
    })
})

/**
 * MARQUES
 */
const J_MENU_MARQUES = '#js-menuMarques'

// Gère le hover sur l'élément MARQUES du menu
$(J_MENU_MARQUES).hover(function (event) {
    const navActifDefaut = document.getElementById('j_menuActifDefaut').value

    $('.navigationGenre').removeClass('menuActive') <
        $('#menuMarques').removeClass('menuActive')
    $(this)
        .children('.menu__container')
        .removeClass('menu__container--marqueActive')
    $('.menu__item__link').removeClass('menu__item__link--active')

    updateBodyOverlayMenu(false)

    if (event.type === 'mouseenter') {
        $('#menuMarques').addClass('menuActive')
        $(this)
            .children('.menu__container')
            .addClass('menu__container--marqueActive')
        updateBodyOverlayMenu(true)
    } else {
        $('#' + navActifDefaut).addClass('menuActive')
        $("[data-idNavGender*='" + navActifDefaut + "'] a").addClass(
            'menu__item__link--active'
        )
    }
})

// Supprime la classe activeLink lors du changement de menu
$('.js_menu_linkactive').hover(function () {
    $(this).siblings().toggleClass('activelink')
})

/**
 * MOBILE
 */

const J_MENU_MOBILE = '.j_nav_mob'
const J_MENU_CATEGORY_MOBILE = '.j_show_subcatMob'
const J_MENU_SUB_CATEGORY_MOBILE = '.j_show_subcatMob > span'
const J_BURGER_MOBILE = '.j_burger'

// Gere le changement de menu
$(J_MENU_MOBILE).on('click', function () {
    const _self = $(this)
    const genre = _self.data(J_GENDER_DATA)

    $(J_MENU_MOBILE).removeClass('isactive')

    $(J_MENU_CATEGORY_MOBILE).removeClass('open')

    // Vérifie si les données du menu ont déjà été chargées
    const isMenuLoaded = Boolean(_self.children('.subCatMenuMob').length)

    _self.addClass('isactive')

    if (isMenuLoaded) {
        // Gère l'offuscation des liens
        addAnchorsEventListeners()
        return
    }

    $.ajax({
        type: 'GET',
        url: '/Layout/Menu/?codegenre=' + genre + '&ismobile=true',
        success: function (response) {
            // Ajoute les catégories au menu
            _self.append(response)

            // Gére l'engistrement des events d'ouverture
            registerSubCategoriesEvents()
            $(J_MENU_CATEGORY_MOBILE).click(function () {
                $(this).toggleClass('open')
            })
        }
    })
})

// Gere l'ouverture des catégories
function registerSubCategoriesEvents() {
    const J_MENU_CATEGORY_MOBILE = '.j_show_subcatMob'
    const J_MENU_SUB_CATEGORY_MOBILE = '.j_show_subcatMob > span'
    $(J_MENU_SUB_CATEGORY_MOBILE).click(function (event) {
        // Evite la propagation du click dans le parent
        event.stopPropagation()

        // Vérifie si le menu est ouvert
        if ($(this).parent('.j_show_subcatMob').hasClass('open')) {
            $(this).parent('.j_show_subcatMob').removeClass('open')
        } else if ($('.j_show_subcatMob').hasClass('open')) {
            $('.j_show_subcatMob').removeClass('open')
            $('.subCatMenuMob').stop().animate({ scrollTop: 0 }, 'slow')
            $(this).parent('.j_show_subcatMob').addClass('open')
        } else {
            $(this).parent('.j_show_subcatMob').addClass('open')
        }

        addAnchorsEventListeners()
    })
}

registerSubCategoriesEvents()
/**
 * HEADER
 */

const J_ZONE_HEADER = '.zone-header'

// Gère l'affichage des catégories au scroll dans le catalogue
$(J_ZONE_HEADER).on('mouseenter', function () {
    $(this).removeClass('minified')

    // Vue Catalogue
    if ($(this).hasClass('fullHeader')) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 0) {
                $(this).addClass('minified').removeClass('fullHeader')
            } else {
                $(this).addClass('fullHeader').removeClass('minified')
            }
        })
    }
})

$(J_ZONE_HEADER).on('mouseleave', function () {
    $(this).addClass('minified')
    $(J_BODY_OVERLAY).removeClass('active')
})

/**
 * CONNEXION / INSCRIPTION
 */
let bOnCheckLoginForm = false

const J_GLOBAL_CONTAINER = '.container'
const J_MENU_LOGIN = '.j-login-menu'
const J_TOOPENLOGINFORM = '.j_to_open_loginForm'
const J_TOOPENPERSONNALSHOPPING = '.j_to_open_personalshop'
const J_BTN_CREER_UN_COMPTE = '.j-btn-connexion'
const J_MENU_PWD = '.j_menu-password-forgot'
const J_MENU_LOGIN_INPUT_EMAIL = '.j_bsForm_email'
const J_MENU_FORM_LOGIN = '#j-connexionHome'
const J_MENU_LOGIN_ERROR = '.j_connexion_error'
const OPEN_CLASS = 'open'

// Gère l'affichage des modales entre la connexion et le personal shopping
const checkFormLoginRemove = function (e) {
    // Rect du formulaire de connexion
    const loginFormRect = document
        .querySelector('.dropdown-menu')
        .getBoundingClientRect()

    // Vérifie si la souris se trouve au dessus du formulaire de connexion
    const isMouseInsideForm =
        loginFormRect.left <= e.clientX &&
        e.clientX <= loginFormRect.right &&
        loginFormRect.top <= e.clientY &&
        e.clientY <= loginFormRect.bottom

    if (isMouseInsideForm) {
        return
    }

    if ($(J_TOOPENLOGINFORM).hasClass(OPEN_CLASS)) {
        $(J_TOOPENLOGINFORM).removeClass(OPEN_CLASS)
    }

    if ($(J_TOOPENPERSONNALSHOPPING).hasClass(OPEN_CLASS)) {
        $(J_TOOPENPERSONNALSHOPPING).removeClass(OPEN_CLASS)
    }

    bOnCheckLoginForm = false
}

$(J_GLOBAL_CONTAINER).hover(function (e) {
    if (bOnCheckLoginForm) {
        checkFormLoginRemove(e)
    }
})

// Affichage la modale de connexion
$(J_MENU_LOGIN).hover(function () {
    if ($(J_TOOPENPERSONNALSHOPPING).hasClass(OPEN_CLASS)) {
        $(J_TOOPENPERSONNALSHOPPING).removeClass(OPEN_CLASS)
    }
    $(J_TOOPENLOGINFORM).addClass(OPEN_CLASS)
    bOnCheckLoginForm = true
})

// Gère le click sur Créer un compte
$(J_BTN_CREER_UN_COMPTE).on('click', function (event) {
    event.preventDefault()
    modal.creer(
        'modalInscription',
        'j_modal_wishlist_catalogue modal-connexion poppin-newconnexion in',
        window.location.origin + '/Inscription/ModalConnexionInscription/',
        initModalConnexionInscription
    )
})

// Initialise la modale pour la connexion
function initModalConnexionInscription() {
    inscriptionModule.Process()

    $('#passwordPerdu').on('click', function () {
        modal.creer(
            'modalMotdepassePerdu',
            'fade m-password-forgotten modal-pass-forgot in',
            window.location.origin + '/Inscription/ModalMotdepassePerdu/',
            initModalMotdepassePerdu
        )
    })
}

// Gère le click sur mot de passe oublié
$(J_MENU_PWD).on('click', function (event) {
    // Prévient la propagation de l'événement au formulaire
    event.stopPropagation()

    event.preventDefault()

    modal.creer(
        'modalMotdepassePerdu',
        'fade m-password-forgotten modal-pass-forgot in',
        window.location.origin + '/Inscription/ModalMotdepassePerdu/',
        initModalMotdepassePerdu
    )
})

// Initialise la modale pour la connexion
function initModalMotdepassePerdu() {
    const J_PASSWORD_FORGOTTEN_FORM_ID = '.j-pwdForgotten'
    const J_PASSWORD_FORGOTTEN_ID = '.modal-pass-forgot'

    import('Modules/bootstrapValidationForm').then(
        (bootstrapValidationForm) => {
            bootstrapValidationForm.default.initModalForm(
                J_PASSWORD_FORGOTTEN_ID,
                J_PASSWORD_FORGOTTEN_FORM_ID,
                inscriptionConnexionCustomAction.recoverPassword
            )
        }
    )
}

// Submit le formulaire de connexion
$(J_MENU_FORM_LOGIN).on('submit', function (e) {
    // Vérifie l'email
    // S'il n'est pas conforme on affiche un message d'erreur
    if (
        $(J_MENU_LOGIN_INPUT_EMAIL).val() === undefined ||
        $(J_MENU_LOGIN_INPUT_EMAIL).val() === ''
    ) {
        const error = $(J_MENU_LOGIN_INPUT_EMAIL).attr(
            'data-bv-notempty-message'
        )
        $(J_MENU_LOGIN_ERROR).empty().append(error)
        $(J_MENU_LOGIN_ERROR).removeClass('hidden')
        return false
    }

    // Prévient le rechargement de la page
    if (e.preventDefault) {
        e.preventDefault()
    } else {
        e.returnValue = false
    }

    // Connexion
    import('Modules/connexion').then(({ default: { processConnexion } }) => {
        processConnexion(e)
    })
})

/**
 * PERSONAL SHOPPING
 */

// Affichage la modale personal shopping
$(J_TOOPENPERSONNALSHOPPING).hover(function (e) {
    if ($(J_TOOPENLOGINFORM).hasClass(OPEN_CLASS)) {
        $(J_TOOPENLOGINFORM).removeClass(OPEN_CLASS)
    }
    $(this).addClass(OPEN_CLASS)
    bOnCheckLoginForm = true
})

/**
 * POP IN 3M
 */
new PopIn3M('#modal-3m')
    .setEvent('click')
    .setEventElement('.ctaPersoShop')
    .build()

//new menu handler mobile
function menuHandlerMobile() {
    // Sélection des éléments
    const main = document.querySelector('.main-container-mobile')
    const searchBar = document.querySelector('.container-header')
    const headerEl = document.querySelector('.wrapper-logo-nav')
    const burgerMenu = document.querySelector('.j_burger')
    const menuContent = document.querySelector('.nav-mobile')
    const headBanner = document.querySelector('.container-headBanner')
    const fullHeader = document.querySelector('#nav-mob')
    const iconCloseMenu = document.querySelector('#closeBurger')
    const IconBurger = document.querySelector('#burger')

    // État du menu
    let isMenuOpen = false

    // Vérifier que les éléments existent
    if (!main || !searchBar || !headerEl || !burgerMenu || !menuContent) {
        return
    }
    // Fonction pour montrer le header complet
    const showFullHeader = () => {
        headerEl.classList.remove('enabled')
    }
    const showheadBanner = (display) => {
        if (headBanner) {
            headBanner.classList.add(`${display}`)
        }
    }
    const hideheadBanner = (display) => {
        if (headBanner) {
            headBanner.classList.remove(`${display}`)
        }
    }
    const iconMenuOpen = () => {
        IconBurger.style.display = 'none'
        iconCloseMenu.style.display = 'block'
    }
    const iconMenuClose = () => {
        IconBurger.style.display = 'block'
        iconCloseMenu.style.display = 'none'
    }

    const overflowBody = () => {
        document
            .querySelector('html')
            .classList.toggle('overflow-hidden', isMenuOpen)
    }

    // Fonction pour ouvrir le menu
    const openMenu = () => {
        isMenuOpen = true
        menuContent.style.display = 'block'
        overflowBody()
        iconMenuOpen()
        showFullHeader() // Toujours montrer le header complet quand le menu est ouvert
        fullHeader.style.top = '0'
        window.dispatchEvent(new Event('menuOpen'))
    }

    // Fonction pour fermer le menu
    const closeMenu = () => {
        isMenuOpen = false
        menuContent.style.display = 'none'
        fullHeader.style.top = 'unset'
        // Réappliquer la classe de scroll si nécessaire
        if (window.scrollY > headerEl.offsetHeight + searchBar.offsetHeight) {
            headerEl.classList.add('enabled')
        }
        iconMenuClose()
        overflowBody()
        window.dispatchEvent(new Event('menuClose'))
    }

    // Gérer le clic sur le menu burger
    burgerMenu.addEventListener('click', (event) => {
        if (isMenuOpen) {
            closeMenu()
            showheadBanner('enabled')
            return
        }
        openMenu()
        hideheadBanner('enabled')
    })

    // Ajouter un élément sentinelle au début de main
    const sentinel = document.createElement('div')
    sentinel.style.height = '1px'
    sentinel.style.width = '100%'
    sentinel.style.visibility = 'hidden'
    main.insertBefore(sentinel, main.firstChild)

    // Définir le handler pour l'Intersection Observer
    const handler = (entries) => {
        const entry = entries[0]

        // Ne pas modifier l'état du header si le menu est ouvert
        if (isMenuOpen) return

        if (entry.isIntersecting) {
            // La sentinelle est visible, on est au début de main
            headerEl.classList.remove('enabled')
            hideheadBanner('enabled')
        } else {
            // On a scrollé au-delà de la sentinelle
            headerEl.classList.add('enabled')
            showheadBanner('enabled')
        }
    }

    // Options de l'observer
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    }

    // Créer et initialiser l'observer
    const observer = new IntersectionObserver(handler, options)

    // Observer la sentinelle
    observer.observe(sentinel)

    // Vérification initiale au chargement
    if (
        !isMenuOpen &&
        window.scrollY > headerEl.offsetHeight + searchBar.offsetHeight
    ) {
        headerEl.classList.add('enabled')
    } else {
        headerEl.classList.remove('enabled')
    }
    menuContent.style.display = 'none'
}

menuHandlerMobile()

$('.linkBlocked').click(function (e) {
    e.preventDefault()
})

/**
 * Ajoute un event listener au click sur les balises <a>
 * Permet de gérer à la fois les href et data
 */
function addAnchorsEventListeners() {
    $('#header a:not(.linkBlocked)').unbind('click')
    $('#header a:not(.linkBlocked)').on('click', function (e) {
        e.stopImmediatePropagation()

        if (
            !$(this).hasClass('linkAjaxReload') &&
            !$(this).hasClass('linkAjaxMenu')
        ) {
            return
        }

        window.location = $(this).attr('data')
    })
}
